import {UUID} from '@/plugins/common'
import _ from 'lodash'

export default class Candidate {
  id = ''
  // 目标 id, 直属上司和发起人只需要存放 type, 不用存放目标 id
  targetId
  // 目标类型 department/post/user/sponsor/superiors
  type = ''
  name = ''
  defaultValue = false

  constructor (args = {}) {
    _.merge(this, args)
  }

  static create (args) {
    args.id = UUID.create()
    let candidate = new Candidate(args)
    return candidate
  }

  static load (args) {
    args.id = UUID.create()
    let candidate = new Candidate(args)
    return candidate
  }
}



// WEBPACK FOOTER //
// ./src/store/process/candidate.js